import { API_BASE_URL } from "../config/apiConfig";
// Activities API service for discover functionality
import axios from 'axios';
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
});

export const ActivitiesApi = {
  // Search for activities by location
  searchActivities: async (location, filterByInterests = true, token) => {
    try {
      if (!location || location.length < 2) {
        throw new Error('Location must be at least 2 characters');
      }

      const requestBody = {
        location: location.trim(),
        filter_by_interests: filterByInterests
      };

      //console.log('Searching activities with:', requestBody);

      const response = await api.post('/discover/activities/search', 
        requestBody,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      
      //console.log('Activities search response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Activities search error:', error.response?.data || error.message);
      throw error;
    }
  },

  // Get popular destinations (fallback when API fails)
  getPopularDestinations: () => {
    return [
      { name: 'Paris', country: 'France', activityCount: 245 },
      { name: 'Tokyo', country: 'Japan', activityCount: 312 },
      { name: 'New York', country: 'United States', activityCount: 189 },
      { name: 'London', country: 'United Kingdom', activityCount: 267 },
      { name: 'Barcelona', country: 'Spain', activityCount: 198 },
      { name: 'Rome', country: 'Italy', activityCount: 223 },
      { name: 'Dubai', country: 'UAE', activityCount: 156 },
      { name: 'Sydney', country: 'Australia', activityCount: 134 },
      { name: 'Amsterdam', country: 'Netherlands', activityCount: 145 },
      { name: 'Bangkok', country: 'Thailand', activityCount: 278 }
    ];
  },

  // Get recent searches from localStorage
  getRecentSearches: () => {
    try {
      const recent = localStorage.getItem('activities_recent_searches');
      return recent ? JSON.parse(recent) : [];
    } catch (error) {
      console.error('Error getting recent searches:', error);
      return [];
    }
  },

  // Save recent search to localStorage
  saveRecentSearch: (destination) => {
    try {
      const recent = ActivitiesApi.getRecentSearches();
      const updated = [
        destination,
        ...recent.filter(item => item.name !== destination.name)
      ].slice(0, 5); // Keep only 5 recent searches
      
      localStorage.setItem('activities_recent_searches', JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error('Error saving recent search:', error);
      return [];
    }
  },

  // Format activity for display
  formatActivityDisplay: (activity) => {
    if (!activity) return '';
    
    // Handle different response formats from API
    if (activity.name && activity.location) {
      return `${activity.name} in ${activity.location}`;
    }
    
    if (activity.title && activity.city) {
      return `${activity.title} in ${activity.city}`;
    }
    
    // Fallback for unknown format
    return activity.name || activity.title || 'Unknown Activity';
  },

  // Get dummy activities for demo/fallback with unique images
  getDummyActivities: () => {
    return [
      {
        id: 1,
        name: 'Eiffel Tower Tour',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1543349689-9a4d426bee8e?w=400&h=300&fit=crop',
        rating: 4.8,
        reviews: 1234,
        price: 45,
        originalPrice: 65,
        category: 'Sightseeing'
      },
      {
        id: 2,
        name: 'Louvre Museum Visit',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1499856871958-5b9627545d1a?w=400&h=300&fit=crop',
        rating: 4.9,
        reviews: 2345,
        price: 35,
        originalPrice: null,
        category: 'Museums'
      },
      {
        id: 3,
        name: 'Seine River Cruise',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?w=400&h=300&fit=crop',
        rating: 4.7,
        reviews: 987,
        price: 55,
        originalPrice: 75,
        category: 'Tours'
      },
      {
        id: 4,
        name: 'Paris Food Tour',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop',
        rating: 4.9,
        reviews: 567,
        price: 95,
        originalPrice: null,
        category: 'Food & Drink'
      },
      {
        id: 5,
        name: 'Versailles Palace',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1551410224-699683e15636?w=400&h=300&fit=crop',
        rating: 4.8,
        reviews: 1890,
        price: 50,
        originalPrice: 70,
        category: 'Sightseeing'
      },
      {
        id: 6,
        name: 'Montmartre Walking Tour',
        location: 'Paris, France',
        image: 'https://images.unsplash.com/photo-1550340499-a6c60fc8287c?w=400&h=300&fit=crop',
        rating: 4.6,
        reviews: 765,
        price: 30,
        originalPrice: null,
        category: 'Walking Tours'
      }
    ];
  }
};

export default ActivitiesApi;

